export const REDIRECTING_TO_LOGIN_ERROR =
    "Oops! It looks like you're not logged in. No worries, we're taking you to the login page now.";
export const INTERNAL_REQUIRED_LOGIN_ERROR =
    'As an Inker, you need to login using Okta. You will now be redirected to the login page.';

export const knownAuthErrors = [INTERNAL_REQUIRED_LOGIN_ERROR, REDIRECTING_TO_LOGIN_ERROR];
